import React, { useState } from "react";
import { signRubricUpload } from "../../services/rubricAdminService";

interface Props {
  rubricId: string;
  getToken: () => string | undefined;
  artifacts: string[];
  onChange: (next: string[]) => void;
}

const ArtifactUploader: React.FC<Props> = ({ rubricId, getToken, artifacts, onChange }) => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onFile = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    e.target.value = ""; // allow re-selecting the same file
    if (!file) return;
    setBusy(true);
    setError(null);
    try {
      const key = await signRubricUpload(rubricId, file, getToken());
      onChange([...artifacts, key]);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Upload failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mt-2">
      <div className="flex flex-col gap-1">
        {artifacts.map((key, i) => (
          <div key={key} className="flex items-center gap-2 text-xs text-slate-300">
            <span className="truncate">{key.split("/").pop()}</span>
            <button
              type="button"
              className="text-error"
              onClick={() => onChange(artifacts.filter((_, j) => j !== i))}
            >
              Remove
            </button>
          </div>
        ))}
      </div>
      <label className="text-xs text-slate-400 cursor-pointer">
        {busy ? "Uploading…" : "+ Add artifact"}
        <input type="file" className="hidden" disabled={busy} onChange={onFile} />
      </label>
      {error && <div className="text-error text-xs mt-1">{error}</div>}
    </div>
  );
};

export default ArtifactUploader;
